export var IDebugEnv;
(function (IDebugEnv) {
    IDebugEnv["DEV"] = "DEV";
    IDebugEnv["PRE_PROD"] = "PRE_PROD";
    IDebugEnv["PROD"] = "PROD";
})(IDebugEnv || (IDebugEnv = {}));
export var Tenancy;
(function (Tenancy) {
    Tenancy["DEV"] = "marine-samraj/dev";
    Tenancy["TEST"] = "marine-samraj/test";
    Tenancy["PROD"] = "marine-samraj/prod";
})(Tenancy || (Tenancy = {}));
